<template>
  <v-app>
    <the-snackbar />
    <the-drawer />
    <the-app-bar />
    <the-dialog />
    <v-main>
      <v-container fluid>
        <router-view v-slot="{ Component }">
          <component :is="Component" />
          <!-- <v-fade-transition hide-on-leave>
          </v-fade-transition> -->
        </router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TheAppBar from './components/TheAppBar.vue'
import TheDrawer from './components/TheDrawer.vue'
import TheSnackbar from './components/TheSnackbar.vue'
import TheDialog from './components/TheDialog.vue'
import { usePermissionStore } from './stores/permission'

export default defineComponent({
  components: {
    TheAppBar,
    TheDrawer,
    TheSnackbar,
    TheDialog,
  },
  setup() {
    // This call is here to "touch" permission store whenever there's no login call on the
    // application's lifecycle. That's needed because pinia persistence plugin it's lazy
    // and will only hydrate the store from storage if used.
    usePermissionStore()
  },
})
</script>

<style lang="scss">
html {
  overflow: auto;
}

div.v-application {
  background-image: url('./assets/images/background_home.svg');
  background-size: cover;
}

.remove-image {
  background-image: none !important;
  background-color: #f3f3f3 !important;
}
</style>
